import React from 'react';
import { Spin } from 'antd';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="flex justify-center items-center min-h-screen">
      <Spin size="large">
        <div style={{ marginTop: '16px' }}>加载中...</div>
      </Spin>
    </div>
  );
};

export default LoadingSpinner;



